import { render, staticRenderFns } from "./resolutionVoteSummary.vue?vue&type=template&id=45d53408&"
import script from "./resolutionVoteSummary.vue?vue&type=script&lang=js&"
export * from "./resolutionVoteSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports